import { MedicalReviewDeterminationConst } from '../../components/CaseDetails/PhysicianReviewSecondPart';

const nurseInitialDetermination = {
    RecommendedApproval: 'Recommended Approval',
    RecommendedPartiallyApproval: 'Recommended Partial Approval',
    RecommendedDenial: 'Recommended Denial'
};

export const mdNurseDeterminationComparer = (
    nurseDetermination?: string,
    mdDetermination?: string
) => {

    const nurseToMDMap: Record<string, string> = {
        [nurseInitialDetermination.RecommendedApproval]: MedicalReviewDeterminationConst.Approved,
        [nurseInitialDetermination.RecommendedPartiallyApproval]:
            MedicalReviewDeterminationConst.PartiallyApproved,
        [nurseInitialDetermination.RecommendedDenial]: MedicalReviewDeterminationConst.Denied
    };

    const nurseDeterminationValue = nurseToMDMap[nurseDetermination || ''];

    return nurseDeterminationValue ? nurseDeterminationValue === mdDetermination : true;
};
